import React, {memo} from 'react'

/* Styles */
import s from './vertical-features-skeleton.scss'

const VerticalFeaturesSkeleton = memo(() => {
  return (
    <div className={s.verticalFeaturesSkeleton}>
      <div className={s.featureItem}></div>
      <div className={s.featureItem}></div>
      <div className={s.featureItem}></div>
    </div>
  )
})

export default VerticalFeaturesSkeleton
